export function getCookieValue(cookieName: string): string {
  var match = document.cookie.match(new RegExp("(^| )" + cookieName + "=([^;]+)"));
  if (match) {
    return match[2];
  }
  return "";
}
